export default __webpack_public_path__ + "assets/png/bf0fd0a9ebab337e93766453c6475911.png";